import React, { useState, useEffect } from "react";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
import useFetchPost from "../hooks/useFetchPost";
import useFetchGet from "../hooks/useFetchGet";
import CustomSelect from "../../multiselectcustom/CustomSelect";
import CheckPicker from "rsuite/CheckPicker";
import SelectPicker from "rsuite/SelectPicker";
import Avatar from "rsuite/Avatar";

// (Optional) Import component styles. If you are using Less, import the `index.less` file.
import "rsuite/CheckPicker/styles/index.css";
// import "rsuite/dist/rsuite.min.css";
// import "../../../assets/css/rsuite.css";

import Swal from "sweetalert2";
import $ from "jquery";
import { toast, Bounce } from "react-toastify";

const ManageMuviOwnership = ({ data, setApiRun }) => {
	const { fetchPostData, error } = useFetchPost();
	const { fetchData } = useFetchGet();

	const [selectedSalesManager, setSelectedSalesManager] = useState(null);
	const [selectedTseOwner, setSelectedTseOwner] = useState(null);
	const [selectedAccountManager, setSelectedAccountManager] = useState(null);

	const [hasInitialized, setHasInitialized] = useState(false);
	const [accountManagerData, setAccountManagerData] = useState([]);
	const [salesManagerData, setSalesManagerData] = useState([]);
	const [tseOwnerData, setTseOwnerData] = useState([]);

	//in Edit time selected value are pre selected end
	function decryptconfigdata(configkey) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return plaintext;
	}

	function decrypt(findresponse, flg) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var res = flg ? findresponse.encdata : findresponse;
		var bytes = CryptoJS.AES.decrypt(res, key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return JSON.parse(plaintext);
	}
	const handleClose = () => {
		const manageMuviOwnershipModal = document.getElementById("manageMuviOwnership");
		manageMuviOwnershipModal.classList.remove("show");
		manageMuviOwnershipModal.style.display = "none";
		setSelectedSalesManager(null);
		setSelectedTseOwner(null);
		setSelectedAccountManager(null);
	};
	const handleChangeAccountManager = (selectedOption) => {
		if (selectedOption === null) {
			setSelectedAccountManager(null);
		} else {
			setSelectedAccountManager(selectedOption);
		}
	};
	const handleChangeSalesManager = (selectedOption) => {
		if (selectedOption === null) {
			setSelectedSalesManager(null);
		} else {
			setSelectedSalesManager(selectedOption);
		}
	};
	const handleChangeTseOwner = (selectedOption) => {
		if (selectedOption === null) {
			setSelectedTseOwner(null);
		} else {
			setSelectedTseOwner(selectedOption);
		}
	};

	// Function to handle data submission
	const handleSubmit = async () => {
		const postData = {
			product_key: data && data.product_key,
			customer_id: data && data.customer_id,
			sales_manager: selectedSalesManager,
			tse_owner: selectedTseOwner,
			account_manager: selectedAccountManager,
			is_live: data && data.isLive,
		};

		let crmStagingUrl = process.env.REACT_APP_CRM + "/muvi6/manage-muvi-ownership";

		let responseData;
		try {
			responseData = await fetchPostData(crmStagingUrl, postData);
			// console.log("Response:", responseData);
		} catch (error) {
			console.error("Error:", error);
		}
		if (responseData && responseData.code == 200) {
			setApiRun(true); // customer list api run
			setSelectedSalesManager(null);
			setSelectedTseOwner(null);
			setSelectedAccountManager(null);
			toast.success(responseData.message, {
				position: "top-right",
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "light",
				transition: Bounce,
			});
		} else {
			const errorMessage = responseData && responseData.message ? responseData.message : "An error occurred";
			setSelectedSalesManager(null);
			setSelectedTseOwner(null);
			setSelectedAccountManager(null);
			toast.error(errorMessage, {
				position: "top-right",
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "light",
				transition: Bounce,
			});
			console.warn("Something went wrong .in change to muvi ownership");
		}

		// Close the modal
		const manageMuviOwnershipModal = document.getElementById("manageMuviOwnership");
		manageMuviOwnershipModal.classList.remove("show");
		manageMuviOwnershipModal.style.display = "none";
	};

	const getAccountManager = async () => {
		try {
			const responseData = await fetchData(
				`${decryptconfigdata("apiUrl")}/tattle/GetGroupMembers?email=accountmanagement@muvi.com`
			);
			if (responseData.code == 200) {
				setAccountManagerData(responseData.data);
			} else {
				setAccountManagerData([]);
			}
		} catch (error) {
			console.error("Error:", error);
		}
	};
	const getSalesManager = async () => {
		try {
			const responseData = await fetchData(
				`${decryptconfigdata("apiUrl")}/tattle/GetGroupMembers?email=sales@muvi.com`
			);
			if (responseData.code == 200) {
				setSalesManagerData(responseData.data);
			} else {
				setSalesManagerData([]);
			}
		} catch (error) {
			console.error("Error:", error);
		}
	};
	const getTseOwnerManager = async () => {
		try {
			const responseData = await fetchData(
				`${decryptconfigdata("apiUrl")}/tattle/GetGroupMembers?email=support@muvi.com`
			);
			if (responseData.code == 200) {
				setTseOwnerData(responseData.data);
			} else {
				setTseOwnerData([]);
			}
		} catch (error) {
			console.error("Error:", error);
		}
	};

	useEffect(() => {
		if (data != null && !hasInitialized) {
			setHasInitialized(true); // Mark as initialized
			getAccountManager();
			getSalesManager();
			getTseOwnerManager();
		}

		if (data && data.account_manager) {
			setSelectedAccountManager(data.account_manager); // Set the pre-selected value in edit mode
		}
		if (data && data.sales_manager) {
			setSelectedSalesManager(data.sales_manager); // Set the pre-selected value in edit mode
		}
		if (data && data.tse_owner) {
			setSelectedTseOwner(data.tse_owner); // Set the pre-selected value in edit mode
		}
	}, [data, hasInitialized]);

	useEffect(() => {
		setSelectedSalesManager();
	}, []);

	return (
		<div
			className="modal fade"
			id="manageMuviOwnership"
			tabindex="-1"
			role="dialog"
			aria-labelledby="manageMuviOwnershipLabel"
		>
			<div className="modal-dialog" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<button
							type="button"
							className="close"
							data-dismiss="modal"
							aria-label="Close"
							onClick={handleClose}
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 className="modal-title" id="manageMuviOwnershipLabel">
							Manage Muvi Ownership
						</h4>
					</div>
					<div className="modal-body">
						<div className="alert alert-info" role="alert">
							Note: Assigning an account manager will mark this customer as Key Account, to Unmark it
							please open customer details page and Unmark it.
						</div>

						<form>
							<div class="form-group">
								<label for="recipient-name" className="control-label">
									Account Manager
								</label>
								<SelectPicker
									data={accountManagerData.map((item) => {
										return {
											label: item.name,
											value: item.user_uuid,
											imgUrl: item.attachment,
										};
									})}
									value={selectedAccountManager}
									onChange={handleChangeAccountManager}
									style={{ width: "100%", zIndex: 1100 }}
									block={true}
									placeholder="Select Account Manager"
									container={() => document.getElementById("manageMuviOwnership")}
									renderMenuItem={(label, item) => (
										<div style={{ display: "flex", alignItems: "center" }}>
											<Avatar src={item.imgUrl} size="xs" circle style={{ marginRight: 10 }} />
											{label}
										</div>
									)}
									renderValue={(value, item) => {
										if (!item) return <span>Select Sales Manager</span>;
										return (
											<div style={{ display: "flex", alignItems: "center" }}>
												<Avatar
													src={item.imgUrl}
													size="xs"
													circle
													style={{ marginRight: 10 }}
												/>
												{item.label}
											</div>
										);
									}}
								/>

								{/* <CustomSelect
									value={selectedAccountOption}
									options={activeUsers.map((item) => {
										return {
											label: item.name,
											value: item.user_uuid,
											image: item.profile_image,
										};
									})}
									onChange={handleChangeAccountManager}
								/> */}
							</div>
							<div class="form-group">
								<label for="recipient-name" className="control-label">
									Sales Manager
								</label>
								<SelectPicker
									data={salesManagerData.map((item) => {
										return {
											label: item.name,
											value: item.user_uuid,
											imgUrl: item.attachment,
										};
									})}
									value={selectedSalesManager}
									onChange={handleChangeSalesManager}
									style={{ width: "100%", zIndex: 1100 }}
									block={true}
									placeholder="Select Sales Manager"
									container={() => document.getElementById("manageMuviOwnership")}
									renderMenuItem={(label, item) => (
										<div style={{ display: "flex", alignItems: "center" }}>
											<Avatar src={item.imgUrl} size="xs" circle style={{ marginRight: 10 }} />
											{label}
										</div>
									)}
									renderValue={(value, item) => {
										if (!item) return null; // Handle case where item is undefined

										return (
											<div style={{ display: "flex", alignItems: "center" }}>
												<Avatar
													src={item.imgUrl}
													size="xs"
													circle
													style={{ marginRight: 10 }}
												/>
												{item.label}
											</div>
										);
									}}
								/>
								{/* <CustomSelect
									value={selectedSalesOption}
									options={activeUsers.map((item) => {
										return {
											label: item.name,
											value: item.user_uuid,
											image: item.profile_image,
										};
									})}
									onChange={handleChangeSalesManager}
								/> */}
							</div>
							<div class="form-group">
								<label for="recipient-name" className="control-label">
									TSE Owner
								</label>
								<SelectPicker
									data={tseOwnerData.map((item) => {
										return {
											label: item.name,
											value: item.user_uuid,
											imgUrl: item.attachment,
										};
									})}
									value={selectedTseOwner}
									onChange={handleChangeTseOwner}
									style={{ width: "100%", zIndex: 1100 }}
									block={true}
									placeholder="Select TSE Owner"
									container={() => document.getElementById("manageMuviOwnership")}
									renderMenuItem={(label, item) => (
										<div style={{ display: "flex", alignItems: "center" }}>
											<Avatar src={item.imgUrl} size="xs" circle style={{ marginRight: 10 }} />
											{label}
										</div>
									)}
									renderValue={(value, item) => {
										if (!item) return null; // Handle case where item is undefined

										return (
											<div style={{ display: "flex", alignItems: "center" }}>
												<Avatar
													src={item.imgUrl}
													size="xs"
													circle
													style={{ marginRight: 10 }}
												/>
												{item.label}
											</div>
										);
									}}
									onOpen={() => {
										setTimeout(() => {
											const menu = document.querySelector(
												".rs-picker-select-menu .rs-picker-select-menu-items"
											);
											if (menu) {
												menu.style.maxHeight = "none";
												menu.style.maxHeight = "150px"; // Set your custom max-height
											}
										}, 200); // Ensure the menu is rendered before modifying
									}}
								/>
								{/* <CustomSelect
									value={selectedTseOption}
									options={activeUsers.map((item) => {
										return {
											label: item.name,
											value: item.user_uuid,
											image: item.profile_image,
										};
									})}
									onChange={handleChangeTseOwner}
								/> */}
							</div>
						</form>
					</div>
					<div className="modal-footer">
						<span type="button" className="btn btn-blue" data-dismiss="modal" onClick={handleClose}>
							Close
						</span>
						<span type="button" className="btn btn-primary" data-dismiss="modal" onClick={handleSubmit}>
							Submit
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ManageMuviOwnership;



// WEBPACK FOOTER //
// ./src/components/crm/modals/ManageMuviOwnership.jsx